<template>
  <div class="page">
    <el-dialog center class="mzone-vip-guide" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="guide-header">
        <div class="guide-title guide-title-pc">
          QUY TRÌNH NHẬN ĐẶC QUYỀN VIP
        </div>
        <div class="guide-title guide-title-mobile">
          QUY TRÌNH NHẬN ĐẶC QUYỀN VIP (4 BƯỚC)
        </div>
        <div class="guide-subtitle guide-subtitle-pc">
          4 bước đơn giản liên kết nhân vật và nhận trọn bộ đặc quyền VIP
        </div>
        <div class="guide-subtitle guide-subtitle-mobile">
          Thực hiện lần lượt theo thứ tự để nhận quà thành công
        </div>
      </div>

      <div class="guide-list">
        <div class="guide-step" v-for="(item, index) in stepList" :key="index">
          <div class="step-title">{{ item.title }}</div>
          <img class="step-image" :src="item.image" :alt="item.title" />
        </div>
      </div>

      <img class="download-button" src="@/assets/img/vip/mzone/btn.png" alt="Tải ngay Mzone" @click="downloadMzone" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MzoneVipGuide",
  data() {
    return {
      dialogFormVisible: false,
      stepList: [
        {
          title: "Bước 1: Vào mục Của tôi",
          image: require("@/assets/img/vip/mzone/1.png"),
        },
        {
          title: "Bước 2: Liên kết nhân vật",
          image: require("@/assets/img/vip/mzone/2.png"),
        },
        {
          title: "Bước 3: Nhấn Nhận ngay",
          image: require("@/assets/img/vip/mzone/3.png"),
        },
        {
          title: "Bước 4: Chọn Quà & Nhận",
          image: require("@/assets/img/vip/mzone/4.png"),
        },
      ],
    };
  },
  methods: {
    handleClose() {
      this.dialogFormVisible = false;
    },
    downloadMzone() {
      const url = 'https://mz1.vn/toStores';
      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="scss">
$guide-color: #0eb77c;

.mzone-vip-guide {
  /deep/ .el-dialog {
    width: 86% !important;
    max-width: 1500px;
    margin-top: 4vh !important;
    border-radius: 20px;
  }

  /deep/ .el-dialog__header {
    padding: 12px 20px 0;
  }

  /deep/ .el-dialog__body {
    padding: 3px 24px 20px;
  }
}

.guide-header {
  text-align: center;
}

.guide-title {
  color: #1f2937;
  font-size: 28px;
  line-height: 38px;
  font-weight: 800;
}

.guide-subtitle {
  color: $guide-color;
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
}

.guide-title-mobile,
.guide-subtitle-mobile {
  display: none;
}

.guide-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 38px;
  margin-top: 8px;
}

.guide-step {
  position: relative;
  min-width: 0;
  text-align: center;
}

.step-title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 190px;
  box-sizing: border-box;
  padding: 5px 16px;
  margin-bottom: 8px;
  border-radius: 18px;
  background: $guide-color;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
}

.step-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 41, 55, 0.12);
}

.download-button {
  display: block;
  width: 300px;
  max-width: 72%;
  margin: 16px auto 0;
  cursor: pointer;
}

@media screen and (max-width: 1000px) {
  .mzone-vip-guide {
    /deep/ .el-dialog {
      width: 92% !important;
      margin-top: 3vh !important;
    }

    /deep/ .el-dialog__header {
      height: 30px;
      box-sizing: border-box;
      padding: 0;
    }

    /deep/ .el-dialog__headerbtn {
      top: 8px;
      right: 12px;
      z-index: 3;
    }

    /deep/ .el-dialog__body {
      max-height: 89vh;
      padding: 2px 10px 14px;
      overflow-y: auto;
    }
  }

  .guide-title-pc,
  .guide-subtitle-pc {
    display: none;
  }

  .guide-title-mobile,
  .guide-subtitle-mobile {
    display: block;
  }

  .guide-header {
    box-sizing: border-box;
    padding: 0 28px;
  }

  .guide-title {
    font-size: 15px;
    line-height: 21px;
  }

  .guide-subtitle {
    font-size: 10px;
    line-height: 15px;
  }

  .guide-list {
    width: 88%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 30px;
    row-gap: 12px;
    margin: 5px auto 0;
  }

  .step-title {
    min-width: 0;
    max-width: 100%;
    padding: 4px 8px;
    margin-bottom: 6px;
    font-size: 10px;
    line-height: 14px;
  }

  .step-image {
    border-radius: 9px;
  }


  .download-button {
    width: 220px;
    margin-top: 10px;
  }
}

@media screen and (max-width: 480px) {
  .guide-list {
    width: 86%;
    column-gap: 24px;
  }

  .step-title {
    padding: 3px 6px;
    font-size: 9px;
    line-height: 13px;
  }

  .step-arrow {
    right: -21px;
    width: 22px;
    height: 22px;
    font-size: 15px;
  }
}
</style>
